var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[(this.user)?_c('v-app',[(this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1')?_c('AdminDashboard'):_vm._e(),(this.user.RoleGroupId === 2 || this.user.RoleGroupId === '2')?_c('SalesPersonDashboard'):_vm._e(),(this.user.RoleGroupId === 3 || this.user.RoleGroupId === '3')?_c('CustomerDashboard'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }